// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23j8s","select":"styles_select__2vSQ2"};